/**
 * Configuración global del tablero (clave-valor). Hoy solo guarda los nombres que se muestran
 * para las prioridades; la API y la base siguen usando P0..P3.
 */
import { z } from 'zod';
import { ETIQUETA_PRIORIDAD_POR_DEFECTO, PRIORIDADES } from './dominio';

export const LARGO_MAX_ETIQUETA_PRIORIDAD = 20;

const etiquetaSchema = z
  .string()
  .trim()
  .min(1, 'La etiqueta no puede estar vacía.')
  .max(LARGO_MAX_ETIQUETA_PRIORIDAD, `Máximo ${LARGO_MAX_ETIQUETA_PRIORIDAD} caracteres.`);

/** Nombre visible de cada prioridad. Deben ser distintos entre sí (sin importar mayúsculas). */
export const etiquetasPrioridadSchema = z
  .object({
    P0: etiquetaSchema,
    P1: etiquetaSchema,
    P2: etiquetaSchema,
    P3: etiquetaSchema,
  })
  .strict()
  .refine(
    (e) =>
      new Set(PRIORIDADES.map((p) => e[p].toLocaleLowerCase('es'))).size === PRIORIDADES.length,
    { message: 'Las etiquetas deben ser distintas entre sí.' },
  );
export type EtiquetasPrioridad = z.infer<typeof etiquetasPrioridadSchema>;

/** Respuesta de `GET /api/configuracion`. Se extiende con nuevas secciones sin romper nada. */
export const configuracionSchema = z.object({
  prioridades: etiquetasPrioridadSchema,
});
export type Configuracion = z.infer<typeof configuracionSchema>;

/** Copia de las etiquetas por defecto (para no compartir el objeto de las constantes). */
export const etiquetasPrioridadPorDefecto = (): EtiquetasPrioridad => ({
  ...ETIQUETA_PRIORIDAD_POR_DEFECTO,
});
